import { combineReducers } from "redux"
import { createIsLoadedReducer } from "reducers/shared"
import actionTypes from "actions/actionTypes"

const reducers = {}

reducers.isLoaded = createIsLoadedReducer("FETCH_LIBRARY")

reducers.allCategories = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_LIBRARY_SUCCESS:
      return action.response.items.sort((a, b) => a.fields.order - b.fields.order)
    default:
      return state
  }
}

reducers.currentCategorySlug = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_CURRENT_LIBRARY_CATEGORY:
      return action.response
    default:
      return state
  }
}

const library = combineReducers(reducers)

export const getAllLibraryCategories = (state) => state.library.allCategories
export const getLibraryIsLoaded = (state) => state.library.isLoaded
export const getCurrentCategorySlug = (state) => state.library.currentCategorySlug

export default library
